import {
  favouriteTeenSchema,
  type FavouriteTeen,
  type FavouriteTeenInput,
  type Page,
  type PageQuery,
} from '@teentack/shared';
import { apiFetch, post } from '@/lib/api-client';
import { fetchPage } from '@/lib/api-page';

export function fetchFavourites(query: Partial<PageQuery> = {}): Promise<Page<FavouriteTeen>> {
  return fetchPage('/favourites', favouriteTeenSchema, query);
}

export async function addFavourite(input: FavouriteTeenInput): Promise<FavouriteTeen> {
  return favouriteTeenSchema.parse(await post<unknown>('/favourites', input));
}

export async function removeFavourite(teenId: string): Promise<{ removed: boolean }> {
  return apiFetch<{ removed: boolean }>(`/favourites/${teenId}`, { method: 'DELETE' });
}
